export const CHANGE_FACE = 'FaceChange';
export const CHANGE_NAME = 'AskNameChange';
export const PURCHASE_CONTENT = 'ContentPurchase';
export const REFILL_OPPORTUNITY_DECK = 'RefillCards';
export const REFILL_SIX_ACTIONS = 'RefillThreeActions'; // ¯\_(ツ)_/¯
export const REFILL_TWENTY_ACTIONS = 'RefillActions';